import React, { useState, useRef, useEffect } from 'react';
import { Palette, Check } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const ThemeSwitcher = () => {
  const { theme, setTheme, themes } = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="p-2 text-white/60 hover:text-white hover:bg-white/10 rounded-lg transition-all"
        title="Change theme"
      >
        <Palette className="w-4 h-4" />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-64 bg-white rounded-xl shadow-xl border border-gray-100 z-50 animate-scale-in origin-top-right">
          <div className="px-4 py-3 border-b border-gray-100">
            <p className="text-sm font-semibold text-gray-900">Choose Theme</p>
            <p className="text-xs text-gray-400">Customize the app appearance</p>
          </div>
          <div className="p-2 grid grid-cols-3 gap-1">
            {themes.map((t) => {
              const isActive = theme.id === t.id;
              return (
                <button
                  key={t.id}
                  onClick={() => {
                    setTheme(t.id);
                    setIsOpen(false);
                  }}
                  className={`flex flex-col items-center p-3 rounded-xl transition-all ${
                    isActive
                      ? 'bg-gray-100 ring-2 ring-gray-300'
                      : 'hover:bg-gray-50'
                  }`}
                >
                  <div className="relative mb-2">
                    <div
                      className="w-10 h-10 rounded-xl shadow-sm border-2 border-white"
                      style={{ backgroundColor: t.swatch }}
                    />
                    {isActive && (
                      <div className="absolute -top-1 -right-1 w-5 h-5 bg-white rounded-full shadow flex items-center justify-center">
                        <Check className="w-3 h-3 text-green-600" />
                      </div>
                    )}
                  </div>
                  <span className={`text-xs font-semibold ${
                    isActive ? 'text-gray-900' : 'text-gray-600'
                  }`}>
                    {t.name}
                  </span>
                  <span className="text-[10px] text-gray-400 mt-0.5">
                    {t.description}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ThemeSwitcher;
